<script setup lang="ts">
import { EAdminPerm } from '@/types/permissions/AdminPermissionsEnum'
import EditNewConfigKey from '../components/EditNewConfigKey.vue'
import DeviceTemplateKeysView from './components/DeviceTemplateKeysView.vue'
</script>

<template>
    <DeviceTemplateKeysView>
        <EditNewConfigKey :editPermission="EAdminPerm.ADMIN_DEVICES_CONFIG" />
    </DeviceTemplateKeysView>
</template>
